import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isProductEvaluator } from '../../auth/access';
import { buildSafetyReportArtifactPath } from '../../utils/reportFlow';

type Props = {
  children: React.ReactNode;
  mode: 'home' | 'report';
};

function appendSearch(path: string, search: string): string {
  const normalizedSearch = String(search || '').trim();
  if (!normalizedSearch) return path;
  return `${path}${normalizedSearch.startsWith('?') ? normalizedSearch : `?${normalizedSearch}`}`;
}

export default function ExternalSafetyReviewRouteGate({ children, mode }: Props) {
  const { effectiveUser } = useAuth();
  const location = useLocation();
  const { reportId } = useParams<{ reportId: string }>();

  if (isProductEvaluator(effectiveUser)) {
    if (mode === 'report') {
      const target = buildSafetyReportArtifactPath({
        reportId: String(reportId || '').trim(),
      });
      return <Navigate to={appendSearch(target, location.search)} replace />;
    }
    return <Navigate to={appendSearch('/acceptance/reports', location.search)} replace />;
  }

  return <>{children}</>;
}
